import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      display: 'flex',
      background: theme.oysterTheme.cotton,
      borderRadius: '10px',
      flexDirection: 'column',
    },
    emailSendContainer: {
      padding: '30px',
      minHeight: 410,
      height: 410,
    },
    cardFound: {
      display: 'flex',
      height: '207px',
      background: '#FFFFFF',
      borderRadius: '10px',
      flexDirection: 'column',
      padding: '38px 35px',
      justifyContent: 'space-between',
    },
    cardTitle: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    cardSubTitle: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      fontWeight: 400,
      color: '#5B5B5B',
      marginTop: 10,
      marginBottom: 10,
      textAlign: 'justify',
    },
    titleCardFound: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '18px',
      color: '#000000',
      textAlign: 'center',
    },
    titleEmail: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: '18px',
      color: theme.oysterTheme.pine,
    },
    subtitleEmail: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: '14px',
      color: theme.oysterTheme.charcoal,
      marginBottom: '10px',
    },
    container: {
      marginTop: 14,
      display: 'flex',
      alignItems: 'center',
    },
    urlInput: {
      '& fieldset': { border: '1px solid #EBEEF2 !important' },
    },
    icon: {
      color: theme.oysterTheme.oyster,
    },
    button: {
      width: '72px',
      height: '40px',
      borderRadius: '4px',
      fontWeight: 700,
      fontSize: '14px',
      backgroundColor: theme.oysterTheme.oyster,
      border: '2px solid #1FD7AE',
      boxShadow: 'none',
      padding: 8,
      gap: 4,
      marginRight: 0,
    },
    resize: {
      fontSize: 14,
    },
    optionalText: {
      marginTop: 45,
      marginBottom: 45,
      color: '#EEF0F2',
      width: '100%',
      textAlign: 'center',
      borderBottom: '2px dashed #EEF0F2',
      lineHeight: ' 0.2em',
      margin: '10px 0 20px',
      '& span': {
        background: '#ffffff',
        padding: '0 30px',
        fontWeight: 500,
        fontSize: '16px',
      },
    },
  }),
);

export default useStyles;
